<template>
  <div class="signature-list">
    <!-- Loading -->
    <div v-if="isLoading" class="flex items-center justify-center py-6">
      <div class="animate-spin w-5 h-5 border-2 border-primary-500 border-t-transparent rounded-full"></div>
    </div>

    <!-- Empty -->
    <div v-else-if="signatures.length === 0" class="text-center py-6 px-4">
      <PenTool class="w-8 h-8 text-secondary-300 dark:text-secondary-600 mx-auto mb-2" />
      <p class="text-sm text-secondary-400 dark:text-secondary-500">No hay firmas creadas</p>
    </div>

    <!-- Lista -->
    <div v-else class="space-y-1">
      <div
        v-for="sig in signatures"
        :key="sig.id"
        class="group flex items-center justify-between px-3 py-2 rounded-lg hover:bg-secondary-100 dark:hover:bg-secondary-700 transition-colors cursor-pointer"
        @click="$emit('edit', sig)"
      >
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <Star
            v-if="sig.isDefault"
            class="w-3.5 h-3.5 text-amber-500 flex-shrink-0"
            :fill="'currentColor'"
          />
          <div class="flex-1 min-w-0">
            <p class="text-sm font-medium text-secondary-900 dark:text-white truncate">
              {{ sig.name }}
            </p>
            <p class="text-xs text-secondary-400 dark:text-secondary-500 truncate">
              {{ getPreviewText(sig.bodyHtml) }}
            </p>
          </div>
        </div>
        <div class="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            v-if="!sig.isDefault"
            @click.stop="$emit('set-default', sig)"
            class="p-1 hover:bg-secondary-200 dark:hover:bg-secondary-600 rounded transition-colors"
            title="Establecer como predeterminada"
          >
            <Star class="w-3.5 h-3.5 text-secondary-500" />
          </button>
          <button
            @click.stop="$emit('edit', sig)"
            class="p-1 hover:bg-secondary-200 dark:hover:bg-secondary-600 rounded transition-colors"
            title="Editar"
          >
            <Pencil class="w-3.5 h-3.5 text-secondary-500" />
          </button>
          <button
            @click.stop="$emit('delete', sig)"
            class="p-1 hover:bg-red-100 dark:hover:bg-red-900/20 rounded transition-colors"
            title="Eliminar"
          >
            <Trash2 class="w-3.5 h-3.5 text-red-500" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PenTool, Star, Pencil, Trash2 } from 'lucide-vue-next'
import type { EmailSignature } from '@/types/emailSignature'

defineProps<{
  signatures: EmailSignature[]
  isLoading?: boolean
}>()

defineEmits<{
  (e: 'edit', signature: EmailSignature): void
  (e: 'delete', signature: EmailSignature): void
  (e: 'set-default', signature: EmailSignature): void
}>()

function getPreviewText(html: string): string {
  const tmp = document.createElement('div')
  tmp.textContent = html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
  return tmp.textContent || ''
}
</script>
